<template>
  <v-list-item-avatar :class="{ light: light }" color="primary" :size="size">
    {{ initials }}
  </v-list-item-avatar>
</template>

<script>
export default {
  props: {
    initials: String,
    light: Boolean,
    size: {
      type: String,
      default: "45"
    }
  }
};
</script>

<style lang="scss" scoped>
.v-avatar.v-list-item__avatar {
  @include sub-header-bold;
  margin: 0px 10px 0px 0px;
  color: #fff !important;
}

.v-avatar.v-list-item__avatar.light {
  color: $primary-darker !important;
  background: rgba($primary, 0.1) !important;
  border-color: $primary-darker !important;
}
</style>
